import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import BlogMain from "./BlogMain";
import Footer from "../../components/Footer";

const Blog = () => {
  return (
    <>
      <HeaderFour />

      <BlogMain />

      <Footer />
    </>
  );
};

export default Blog;
